<template>
  <div>

    <span class="">
      Нет сохраненных пользователей
    </span>

  </div>
</template>

<script>
import {mapState, mapGetters} from "vuex";

export default {
  name: 'AllUsersListNodata',
  components: {
    mapState
  },
  data () {
    return {

    }
  },
  methods: {
    createMember () {

    }
  },
  computed: {
    ...mapState([
      'currentGroup',
      'allMembersList'
    ]),
    ...mapGetters([
      'getGroup'
    ])
  },
}
</script>
<style scoped lang="scss">

</style>